import { useMutation, useQueryClient } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
/**
 * Update a CLIN (Contract Line Item Number)
 */ export function useUpdateCLIN(projectId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ clinId, ...data })=>{
            // Pass the patch through with field identity preserved. The adapter
            // forwards every set field to the Connect client and the zou handler
            // skips empty values (matching the existing `notes` patch convention).
            await proposalProjectApiConnect.updateCLIN(projectId, clinId, data);
        },
        onSuccess: ()=>{
            // Invalidate CLINs list to refetch with updated data
            queryClient.invalidateQueries({
                queryKey: [
                    'clins',
                    projectId
                ]
            });
        }
    });
}
